<template>
    <div v-show="showMenu">
        <div class="nav-wrapper">
            <div class="nav-container">
                <div v-for="tab in tabs" :key="tab.name" class="nav-item" :class="{ 'active': isActive(tab.path) }" @click="navigate(tab.path)">
                    <div class="icon-container">
                        <v-icon :size="20" :color="isActive(tab.path) ? 'white' : '#999'">{{ tab.icon }}</v-icon>
                        <span class="nav-label">{{ tab.name }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useMainStore } from '@/store'
import { computed, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const router = useRouter()
const route = useRoute()
const store = useMainStore()
const user = computed(() => store.user)
const userType = computed(() => user.value?.type)
const tabs = [
    { name: 'Home', icon: 'mdi-home', path: '/home' },
    { name: 'Verifikasi', icon: 'mdi-qrcode', path: '/verif_petugas' },
    {
        name: 'Riwayat',
        icon: 'mdi-history',
        path: ['/riwayat_transaksi']
    },
]

const isActive = (path) => {
    if (Array.isArray(path)) {
        return path.includes(route.path)
    }
    return route.path === path
}

const navigate = (path) => {
    const targetPath = Array.isArray(path) ? path[0] : path
    if (route.path !== targetPath) router.push(targetPath)
}

const showMenu = ref(false)

const checkVisibility = () => {
    const hiddenRoutes = ['Login', 'Logout', 'Welcome', 'Halaman Tidak Ditemukan']
    const isUserTypeHidden = userType.value !== 4
    const isRouteHidden = hiddenRoutes.includes(route.name || '')

    showMenu.value = !(isRouteHidden || isUserTypeHidden)
}
// Jalankan saat mounted dan saat route berubah
onMounted(checkVisibility)
watch(() => route.name, checkVisibility)
</script>




<style scoped>
.nav-wrapper {
    position: fixed;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
    max-width: 480px;
    width: 100%;
    padding: 0 16px;
    display: flex;
    justify-content: center;
    z-index: 1000;
}

.nav-container {
    background-color: white;
    border-radius: 40px;
    display: flex;
    justify-content: center;
    gap: 12px;
    padding: 10px;
    width: auto;
    max-width: 100%;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.nav-item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    text-decoration: none;
    transition: flex 0.4s cubic-bezier(0.25, 1, 0.5, 1);
}

.nav-item.active {
    flex: 2;
}

.icon-container {
    padding: 10px 13px;
    border-radius: 40px;
    transition: all 0.4s cubic-bezier(0.25, 1, 0.5, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(69, 10, 84, 0.1);
    box-shadow: inset 2px 2px 5px rgba(0, 0, 0, 0.15), inset -2px -2px 5px rgba(255, 255, 255, 0.6);
    overflow: hidden;
}

.nav-item.active .icon-container {
    background-color: rgba(69, 10, 84, 0.849);
    padding: 12px 25px;
    box-shadow: inset 2px 2px 5px rgba(0, 0, 0, 0.5), inset -2px -2px 5px rgba(255, 255, 255, 0.171);
}

.nav-label {
    font-size: 13px;
    font-weight: 600;
    color: white;
    margin-left: 0;
    max-width: 0;
    opacity: 0;
    transition: all 0.4s cubic-bezier(0.25, 1, 0.5, 1);
    white-space: nowrap;
    overflow: hidden;
}

.nav-item.active .nav-label {
    margin-left: 8px;
    max-width: 100px;
    opacity: 1;
}
</style>
